import { useContext } from "react";
import { DeliveryFoodContext } from "../../../../DeliveryFoodContext";
import { DeliveryFoodItemCommissaryCell } from "../../../../types/DeliveryFoodTypes";
import DeliveryFoodCell from "../../DeliveryFoodCell";

export const DeliveryFoodItemCommissaryPrepTimeCell = ({
    config,
}: {
    config: DeliveryFoodItemCommissaryCell;
}) => {
    const { deliveryFoodState } = useContext(DeliveryFoodContext);
    const { commissary, index, ingredient } = config;

    if (deliveryFoodState.mode.display.COM.prepTime === false) {
        return null;
    }

    const key = `prep-time-cell-${index}`;
    const commissaryId: string | number = commissary.data?.id || "";

    if (!commissaryId) {
        return null;
    }

    if (!ingredient.results.COM) {
        return null;
    }

    const summary = ingredient.results.COM.prepTime;

    if (!summary) {
        return null;
    }

    return (
        <DeliveryFoodCell
            key={key}
            fieldName={"prepTime"}
            styleName={"SALE"}
            summary={summary}
            index={index}
            ingredient={ingredient}
            restaurant={commissary}
        />
    );
};
